import { flatten, get, sumBy } from 'lodash';
import { createSelector } from 'reselect';

export const getTransactionHistoryYTD = (state) =>
  state.transactionHistory.transactionsYTD;

const getFundsByAgreementID = (state) => state.userFunds.fundsByAgreementID;

/**
 * @param {state}
 * takes transactionHistory selector and uses history map to
 * construct an array of filtered transactions by tradeDate in the current year
 * returns {Array} currentYearTransactions
 */
export const getCurrentYearRedemptions = createSelector(
  getTransactionHistoryYTD,
  getFundsByAgreementID,
  (transactionHistoryYTD, userFunds) => {
    const temp = flatten(
      Object.keys(transactionHistoryYTD).map((key) => {
        return transactionHistoryYTD[key]
          .filter((transaction) => transaction.category === 'REDEMPTION')
          .map((trans) => {
            const agreementID =
              trans.transactionRecord?.sourcePositionKey?.agreementKey
                ?.agreementID;
            return {
              agreementID: agreementID,
              amount: trans.transactionRecord?.amount,
              state: userFunds[agreementID]?.address?.state,
            };
          });
      })
    );
    const temp2 = {};
    temp.forEach((fund) => {
      temp2[fund.state] += fund.amount;
    });
    return temp2;
  }
);

/**
 * @param {state}
 * returns total of amounts from transactions array created in getCurrentYearRedemptions
 */
export const getCurrentYearRedemptionTotal = createSelector(
  getCurrentYearRedemptions,
  (currentYearRedemptions) => {
    const transactionRecords = currentYearRedemptions.map((redemption) =>
      get(redemption, 'transactionRecord', {})
    );
    return sumBy(transactionRecords, 'amount');
  }
);
